import React, { FC } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Theme,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ClearIcon from '@material-ui/icons/Clear'
import { useQuickOrder } from '@src/components/QuickOrder/utils/quickOrderContext'
import { MODALTYPE } from './enum'
import { lineClamp } from '@src/styles/utils/lineClamp'

const useStyles = makeStyles((theme: Theme) => ({
  actions: {
    padding: theme.spacing(4, 6, 8, 6),
  },
  closeIcon: {
    cursor: 'pointer',
    fontSize: theme.typography.pxToRem(14),
    position: 'absolute',
    right: theme.typography.pxToRem(8),
    top: theme.typography.pxToRem(8),
  },
  dialogTitle: {
    paddingBottom: theme.spacing(3),
  },
  paper: {
    minWidth: 600,
  },
  quotesPaper: {
    minWidth: 840,
  },
  title: {
    ...lineClamp(1),
    fontSize: theme.typography.pxToRem(20),
    letterSpacing: '1px',
    marginTop: theme.spacing(4),
    textTransform: 'uppercase',
  },
}))

const ModalSkeleton: FC<{
  actions: React.ReactNode
  content: React.ReactNode
  onClose: () => void
  open: boolean
  title: React.ReactNode
  type: MODALTYPE
}> = ({ actions, content, onClose, open, title, type }) => {
  const classes = useStyles()
  const { resetPendingItems } = useQuickOrder()

  return (
    <>
      <Dialog
        classes={{
          paper:
            type === MODALTYPE.QuotesModal
              ? classes.quotesPaper
              : classes.paper,
        }}
        TransitionProps={{
          onEnter: () => resetPendingItems(),
        }}
        open={open}
      >
        <DialogTitle
          classes={{
            root: classes.dialogTitle,
          }}
        >
          <ClearIcon onClick={() => onClose()} className={classes.closeIcon} />
          <Typography component="span" className={classes.title} variant="h2">
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent>{content}</DialogContent>
        <DialogActions className={classes.actions}>{actions}</DialogActions>
      </Dialog>
    </>
  )
}

export default ModalSkeleton
